import CandidateOnboardingNameScreenImg from 'src/assets/images/CandidateOnboardingNameScreenImg.png';
import CandidateOnboardingSkillsScreenImg from 'src/assets/images/CandidateOnboardingSkillsScreenImg.png';
import CandidateOnboardingWorkShowcaseScreenImg from 'src/assets/images/CandidateOnboardingWorkShowcaseScreenImg.png';
import StudentRoleIcon from 'src/assets/icons/StudentRole.svg';
import FresherRoleIcon from 'src/assets/icons/FresherRole.svg';
import FreelancerRoleIcon from 'src/assets/icons/FreelancerRole.svg';
import EmployeeRoleIcon from 'src/assets/icons/EmployeeRole.svg';
import SelfEmpoyedRoleIcon from 'src/assets/icons/SelfEmpoyedRole.svg';
import EducatorRoleIcon from 'src/assets/icons/EducatorRole.svg';
import ResearcherRoleIcon from 'src/assets/icons/ResearcherRole.svg';
import NotListedRole from 'src/assets/icons/NotListedRole.svg';
import JobLocationOnSiteIcon from 'src/assets/icons/JobLocationOnSite.svg';
import JobLocationRemoteIcon from 'src/assets/icons/JobLocationRemote.svg';
import JobLocationHybridIcon from 'src/assets/icons/JobLocationHybrid.svg';
import ActivelyLookingIcon from 'src/assets/icons/ActivelyLooking.svg';
import JustExploringIcon from 'src/assets/icons/JustExploring.svg';
import OpenToChangeIcon from 'src/assets/icons/OpenToChange.svg';

export const companyLogoUploadRules = [
  'Make sure your logo is in PNG or JPG format.',
  'Use a logo with a transparent background for better visibility.',
  'Keep your logo dimensions to at least 400 x 400 pixels to ensure clear visibility on high-resolution screens.',
  'Ensure that your logo file size is less than 8 MB.',
  'Avoid using too many colors in your logo, as it can make it look cluttered and difficult to recognize.',
  'Make sure your logo looks good when resized to smaller dimensions, such as in the website header or on mobile devices.',
];

export const uploadCVRules = [
  'File format: Your resume or CV should be in PDF format.',
  'File size: The maximum allowed size for your resume or CV is 2 MB.',
  'Updated information: Please make sure to upload an updated version of your resume or CV that includes your latest experience and skills.',
  'Original and genuine information: All the information mentioned in your resume or CV must be original and truthful. Providing false information can result in your account being suspended or terminated.',
];

export const employerIDVerificationRules = [
  `Company Email: If you have signed up using company email, you don't need to upload any document.`,
  `Company-Issued ID Card: An identity card issued by your company.`,
  `PAN Card/Incorporation Document: A PAN card or any company incorporation document is acceptable for startups.`,
  `Authorization Letter from Company HR: A letter authorizing you to post jobs on the company's behalf.`,
];

export const JOB_TYPE_OPTIONS = [
  {
    label: 'FullTime',
    value: 'FullTime',
  },
  {
    label: 'Contract',
    value: 'Contract',
  },
  {
    label: 'PartTime',
    value: 'PartTime',
  },
  {
    label: 'Temporary',
    value: 'Temporary',
  },
  {
    label: 'Internship',
    value: 'Internship',
  },
  {
    label: 'Fresher',
    value: 'Fresher',
  },
];

export const CANDIDATE_ROLES = [
  {
    label: 'Student',
    imageSrc: StudentRoleIcon,
    value: 'COLLEGE_STUDENT',
  },
  {
    label: 'Fresher',
    imageSrc: FresherRoleIcon,
    value: 'FRESHER',
  },
  {
    label: 'Employee',
    imageSrc: EmployeeRoleIcon,
    value: 'WORKING_PROFESSIONAL',
  },
  {
    label: 'Freelancer',
    imageSrc: FreelancerRoleIcon,
    value: 'FREELANCER',
  },
  {
    label: 'Self-Employed',
    imageSrc: SelfEmpoyedRoleIcon,
    value: 'SELF_EMPLOYED',
  },
  {
    label: 'Educator',
    imageSrc: EducatorRoleIcon,
    value: 'EDUCATOR',
  },
  {
    label: 'Researcher',
    imageSrc: ResearcherRoleIcon,
    value: 'RESEARCHER',
  },
  {
    label: 'Not Listed',
    imageSrc: NotListedRole,
    value: 'NOT_LISTED',
  },
];

export const JOB_LOCATION_TYPES = [
  {
    label: 'On-site',
    imageSrc: JobLocationOnSiteIcon,
    value: 'OnSite',
  },
  {
    label: 'Remote',
    imageSrc: JobLocationRemoteIcon,
    value: 'Remote',
  },
  {
    label: 'Hybrid',
    imageSrc: JobLocationHybridIcon,
    value: 'Hybrid',
  },
];

export const JOB_SEARCH_STATUS = [
  {
    label: 'Actively looking',
    imageSrc: ActivelyLookingIcon,
    value: 'ActivelyLooking',
  },
  {
    label: 'Offering Service',
    imageSrc: OpenToChangeIcon,
    value: 'OpenToChange',
  },
  {
    label: 'Just exploring',
    imageSrc: JustExploringIcon,
    value: 'NotLooking',
  },
];

// EMPLOYER ONBOARDING
export enum EmployerOnboardingScreens {
  AboutYou,
  CompanyDetails,
}

export const EMPLOYER_ONBOARDING_SCREEN_DATA = [
  {
    screenNo: 0,
    title: 'About You',
  },
  {
    screenNo: 1,
    title: 'Company Details',
  },
];

export const EMPLOYER_ONBOARDING_RIGHT_TAB_CONTENT = {
  [EmployerOnboardingScreens.AboutYou]: {
    title: 'Make Your Mark on Jobs',
    description:
      'By providing your names, we can more effectively recognize you and provide you exclusive features of your interest to enhance your hiring process.',
    imageSrc: CandidateOnboardingNameScreenImg,
  },
  [EmployerOnboardingScreens.CompanyDetails]: {
    title: `Your Company's Spotlight`,
    description:
      'Let job seekers know what makes your company amazing. Share key details to build a profile that stands out!',
    imageSrc: CandidateOnboardingWorkShowcaseScreenImg,
  },
};

// PLACEMENT PARTNER ONBOARDING
export enum PlacementPartnerOnboardingScreens {
  AboutYou,
  OrganizationDetails,
  Confirm,
}

export const PLACEMENT_PARTNER_ONBOARDING_SCREEN_DATA = [
  { screenNo: 0, title: 'About You' },
  { screenNo: 1, title: 'Your Organization' },
  { screenNo: 2, title: 'Confirm & Submit' },
];

export const PLACEMENT_PARTNER_ONBOARDING_RIGHT_TAB_CONTENT = {
  [PlacementPartnerOnboardingScreens.AboutYou]: {
    title: 'Place candidates faster',
    description:
      'Tell us who you are. We use this on the invite emails your candidates receive, so they know who added them to Abekus.',
    imageSrc: CandidateOnboardingNameScreenImg,
  },
  [PlacementPartnerOnboardingScreens.OrganizationDetails]: {
    title: 'Tell us about your organization',
    description:
      'A few details about your institute or company help us match your candidates with the right kinds of jobs and roles.',
    imageSrc: CandidateOnboardingWorkShowcaseScreenImg,
  },
  [PlacementPartnerOnboardingScreens.Confirm]: {
    title: 'AI will do the heavy lifting',
    description:
      'Once approved, you can add candidates by email or resume. Our AI will auto-apply on their behalf to relevant jobs. You can pause or remove anyone anytime.',
    imageSrc: CandidateOnboardingSkillsScreenImg,
  },
};

export const EMPLOYER_VERIFICATION_DOCUMENT_INFO = [
  {
    name: 'Company Email',
    descrition: `If you have signed up using company email, you don't need to upload any document.`,
  },
  {
    name: 'Company-Issued ID Card',
    descrition: `An identity card issued by your company.`,
  },
  {
    name: 'PAN Card/Incorporation Document',
    descrition: `For start-ups, a PAN card or any company incorporation document is acceptable.`,
  },
  {
    name: 'Authorization Letter from Company HR',
    descrition: `A letter authorizing you to post jobs on the company's behalf.`,
  },
];
